// CourseList.js
import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { BiEdit } from "react-icons/bi";
import { AiFillDelete } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { getCourses, deleteACourse, resetState } from "../features/courses/courseSlice";
import { Link } from "react-router-dom";
import CustomModal from "../components/CustomModal";

const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
 
  {
    title: "Title",
    dataIndex: "title",
    sorter: (a, b) => a.title.length - b.title.length,
    width: 300,
  },
  {
    title: "Category",
    dataIndex: "category",
    sorter: (a, b) => a.category.length - b.category.length,
  },
  {
    title: "Price",
    dataIndex: "price",
    sorter: (a, b) => a.price - b.price,
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const CourseList = () => {
  const [open, setOpen] = useState(false);
  const [courseId, setCourseId] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetState());
    dispatch(getCourses());
  }, [dispatch]);

  const courseState = useSelector((state) => state.courses.courses);

  const showModal = (id) => {
    setOpen(true);
    setCourseId(id);
  };

  const hideModal = () => {
    setOpen(false);
  };

  const handleDeleteCourse = (id) => {
    dispatch(deleteACourse(id));
    setOpen(false);
    setTimeout(() => {
      dispatch(getCourses());
    }, 100);
  };

  const data = [];
  for (let i = 0; i < courseState.length; i++) {
    data.push({
      key: i + 1,
      title: courseState[i].title,
      category: courseState[i].category,
      price: `KES ${courseState[i].price?.toLocaleString()}`,
      action: (
        <>
          <Link to={`/admin/course/${courseState[i]._id}`} className="fs-3 text-danger">
            <BiEdit />
          </Link>
          <button
            className="ms-3 fs-3 text-danger bg-transparent border-0"
            onClick={() => showModal(courseState[i]._id)}
          >
            <AiFillDelete />
          </button>
        </>
      ),
    });
  }

  return (
    <div>
      <h3 className="mb-4 title">Courses</h3>
      <div>
        <Table columns={columns} dataSource={data} />
      </div>
      <CustomModal
        hideModal={hideModal}
        open={open}
        performAction={() => handleDeleteCourse(courseId)}
        title="Are you sure you want to delete this course?"
      />
    </div>
  );
};

export default CourseList;
